import { defineMessages } from 'react-intl';

export default defineMessages({
    underwritingIssues: {
        id: 'gateway.views.quote-errors-warning.Errors and Warnings',
        defaultMessage: 'Errors and Warnings'
    },
    noOpenErrorsSubmission: {
        id: 'gateway.views.job-errors-warning.There are no underwriting issues associated with this.Submission',
        defaultMessage: 'There are no open errors or warnings associated with this quote.'
    },
    noOpenErrorsPolicyChange: {
        id: 'gateway.views.job-errors-warning.There are no underwriting issues associated with this.PolicyChange',
        defaultMessage: 'There are no open errors or warnings associated with this policy change.'
    },
    noOpenErrorsRenewal: {
        id: 'gateway.views.job-errors-warning.There are no underwriting issues associated with this.Renewal',
        defaultMessage: 'There are no open errors or warnings associated with this renewal.'
    },
});
